import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-wrapper">
      <div className="privacy-card">
        <h1>Privacy Policy</h1>

        <p>
          LogicSphere Technologies Pvt Ltd values your trust and is committed to protecting
          your personal information. This Privacy Policy outlines how we collect, use,
          store, and safeguard your data when you interact with our website or services.
        </p>

        <div className="privacy-divider"></div>

        <h2>Information We Collect</h2>
        <p>
          We may collect personal information such as your name, email address, phone
          number, company details, and project requirements when you contact us, submit
          forms, or engage with our services.
        </p>

        <div className="privacy-divider"></div>

        <h2>Use of Collected Information</h2>
        <p>
          The information collected is used strictly for service delivery, responding
          to inquiries, improving our offerings, internal analysis, and maintaining
          business communication with clients.
        </p>

        <div className="privacy-divider"></div>

        <h2>Data Protection & Security</h2>
        <p>
          We implement appropriate technical and organizational security measures to
          protect your data against unauthorized access, disclosure, alteration, or
          destruction.
        </p>

        <div className="privacy-divider"></div>

        <h2>Third-Party Disclosure</h2>
        <p>
          LogicSphere Technologies Pvt Ltd does not sell, rent, or trade your personal
          information. Data is shared only when required by law or regulatory authorities.
        </p>

        <div className="privacy-divider"></div>

        <h2>Policy Updates</h2>
        <p>
          This Privacy Policy may be updated periodically to reflect changes in our
          practices or legal requirements. Continued use of our services implies
          acceptance of the updated policy.
        </p>

        <div className="privacy-divider"></div>

        <h2>Contact Information</h2>
        <p>
          If you have questions, concerns, or requests regarding this Privacy Policy,
          feel free to reach out to us using the details below.
        </p>

        <div className="contact-box">
          <p><strong>📞 Phone:</strong> +91 7796986889</p>
          <p><strong>📧 Email:</strong> support@logicspheretechnologies.com</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
